import { z } from 'zod';

/**
 * Staff AI content generation (POST /api/v1/ai/generate) — single-shot, no
 * tools. One endpoint, a `task` discriminator. Reuses the tenant's configured
 * AI provider (Settings → AI). Gated by the `ai` module + `ai.use`.
 */
export const AiGenerateSchema = z.object({
  task: z.enum(['description', 'seo', 'translate']),
  /** Product name (description + seo). */
  name: z.string().trim().max(300).optional(),
  /** Category label (description). */
  category: z.string().trim().max(200).optional(),
  /** Brand label (description). */
  brand: z.string().trim().max(200).optional(),
  /** Source content: the product description for `seo`, or the value to translate for `translate` (HTML or text). */
  source: z.string().max(12000).optional(),
  /** translate: target language code, e.g. 'ar'. */
  targetLang: z.string().trim().max(10).optional(),
  /** translate: true ⇒ input is HTML, preserve markup. */
  html: z.boolean().optional(),
  /** Preferred output language for description/seo (e.g. 'ar'); defaults to English. */
  locale: z.string().trim().max(10).optional(),
});
export type AiGenerate = z.infer<typeof AiGenerateSchema>;

/** Result of POST /ai/generate. `text` for description/translate (HTML where applicable); `seo` for the seo task. */
export interface AiGenerateResult {
  text: string | null;
  seo: { title: string; description: string } | null;
}
